import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-order-success-dialog',
    templateUrl: './order-success-dialog.component.html',
    styleUrls: ['./order-success-dialog.component.scss'],
    standalone: false
})
export class OrderSuccessDialogComponent {

  constructor(
    private dialogRef: MatDialogRef<OrderSuccessDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  cancel() {
    this.dialogRef.close();
  }
}